import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { DcOffLineHost } from "../../config";

const ImageType = ({ imageSrc }) => {
  // Construit l'URL complète pour l'image en évitant le double slash
  let fullUrl = null;
  if (imageSrc) {
    if (DcOffLineHost.endsWith("/") && imageSrc.startsWith("/")) {
      fullUrl = DcOffLineHost + imageSrc.substring(1);
    } else if (!DcOffLineHost.endsWith("/") && !imageSrc.startsWith("/")) {
      fullUrl = DcOffLineHost + "/" + imageSrc;
    } else {
      fullUrl = DcOffLineHost + imageSrc;
    }
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        padding: "8px 0",
      }}
    >
      {fullUrl && (
        <a
          href={fullUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginRight: 12, fontSize: 20, color: "#333" }}
        >
          <EyeOutlined />
        </a>
      )}
      {fullUrl && (
        <img
          src={fullUrl}
          alt="Réponse fichier"
          style={{
            height: "auto",
            width: "auto",
            maxHeight: 180,
            maxWidth: 260,
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            objectFit: "contain",
            background: "#fff",
            border: "1px solid #eee",
            display: "block",
          }}
        />
      )}
    </div>
  );
};

export default ImageType;
